// 모듈B(3종 멀티모달 융합 판정) · 모듈C(HITL 자율 품질관리) 다국어
const moduleb = {
  nav: {
    brandTitle: '모듈B · 3종 멀티모달 융합 불량 판정',
    brandSub: '공정 · 비전 · 열화상',
    steps: {
      sync: { title: '샷-제품 동기화', desc: 'Shot-Product Sync' },
      features: { title: '특징 추출·정합', desc: 'Feature Extraction' },
      fusion: { title: '3종 가중 융합', desc: 'Triple Fusion' },
      judgment: { title: '종합 불량 판정', desc: 'Defect Judgment' },
    },
  },
  common: {
    selectProduct: '제품 선택',
    resultOk: '양품',
    resultNg: '불량',
    judgeOk: '정상',
    shotId: '샷 ID',
    productId: '제품 ID',
    time: '시각',
    unitCount: '건',
    newBadge: '신규',
    tempSensitive: '온도민감',
    sources: {
      process: '공정',
      vision: '비전',
      thermal: '열화상',
      temperature: '온도',
    },
  },
  defects: {
    warpage: '휨',
    shrinkage: '수축',
    dimension: '치수',
    surface: '표면결함',
    shortShot: '미성형',
    flash: '버(Flash)',
  },
  sync: {
    subtitle: '공정·비전·열화상 3개 데이터가 동일 제품(1샷=1제품)의 데이터인지 매칭·판단 (Shot-Product Sync 엔진)',
    meta: '수집 라인 사출 1호기 · CAV-A · 실시간',
    timelineTitle: '동일 제품 매칭 타임라인',
    timelineHint: '세로 점선 = 동일 제품으로 매칭된 3개 소스',
    tableTitle: '최근 샷-제품 매칭 현황',
    confidence: '매칭 신뢰도',
    judgement: '판단',
    detailTitle: '매칭 판단 상세',
    refLabel: '매칭된 제품 · 기준시각',
    sourceKeyLabel: '소스별 식별키 / 매칭 신뢰도',
    detailNote: '3개 소스의 식별키·시각을 대조해 동일 제품 여부를 판단합니다. 하나라도 미매칭이면 해당 샷은 융합에서 제외됩니다.',
    drilldown: '{product} 융합 분석 진행',
    drilldownBlocked: '동일 제품 매칭 실패 · 융합 분석 불가',
    matched: '매칭',
    unmatched: '미매칭',
    missing: '(누락)',
    stats: {
      totalShots: '총 샷 수',
      matchRate: '동일 제품 매칭률',
      confidence: '평균 매칭 신뢰도',
      mismatch: '불일치 건수',
    },
    status: {
      match: '일치',
      check: '확인필요',
      mismatch: '불일치',
    },
  },
  features: {
    subtitle: '동기화된 1개 샷에서 3개 모달리티의 특징(시계열·형상·온도장)을 추출하고 동일 제품 좌표계로 정합',
    meta: '대상 샷',
    selectShot: '샷 선택',
    panelProcess: '시계열 · 공정 (Sₚ)',
    panelVision: '형상 · 비전 (Sᵥ)',
    panelThermal: '온도장 · 열화상 (Sₜ)',
    imagePlaceholder: '제품 외관 이미지',
    extracted: '추출 특징',
    registrationTitle: '정합 (Registration) — 비전 ROI · 온도장 좌표를 동일 제품 격자에 정렬',
    visionRoi: '비전 ROI',
    thermalHotspot: '온도 핫스팟',
    regAccuracy: '정합 정확도',
    offsetX: '오프셋 (X)',
    offsetY: '오프셋 (Y)',
    legendVision: '비전 형상 좌표',
    legendThermal: '열화상 온도장 좌표',
    legend: {
      pressure: '사출압력(MPa)',
      velocity: '사출속도(mm/s)',
      holding: '보압(MPa)',
    },
    process: {
      peakPressure: '피크 사출압력',
      holdTime: '보압 시간',
      fillTime: '충전 시간',
      chargeTime: '계량 시간',
      maxSpeed: '최대 사출속도',
      cushion: '쿠션량',
    },
    vision: {
      edgeDensity: '엣지 밀도',
      defectCandidates: '결함 후보 영역',
      contourCompleteness: '윤곽선 완결도',
      roiAreaRatio: 'ROI 면적비',
      roiShape: 'ROI-형상',
      roiDefect: '결함후보',
    },
    thermal: {
      maxTemp: '최고 온도',
      avgTemp: '평균 온도',
      hotspot: '핫스팟 좌표',
      stdDev: '온도 편차(σ)',
    },
  },
  fusion: {
    subtitle: '비전·공정·온도가 각각 정상/불량을 판정하고, 사전에 정해진 고정 가중치로 융합해 최종 융합 점수 S 를 산출 (모듈형 강건 융합)',
    formulaNote: 'γ항(열화상)이 신규 추가되어 온도민감 불량을 직접 판정',
    modalityTitle: '모달리티별 정상/불량 판정 · 고정 가중치',
    fixedWeight: '고정 가중치',
    weightSum: '가중치는 사전 정의된 고정값 (α 35% · β 35% · γ 30%)',
    weightSumNote: '— 결측 시에만 자동 재정규화',
    contribTitle: '기여도 (가중치 × 점수)',
    donutLabel: '융합 S',
    resultTitle: '최종 융합 점수 S',
    thresholdLabel: '판정 임계값',
    verdictNg: 'S ≥ 임계값 → 불량(NG) 후보',
    verdictOk: 'S < 임계값 → 양품(OK) 후보',
    next: '{product} 종합 판정으로',
    degradeTitle: 'Graceful Degradation — 모달리티 결측 시 자동 전환',
    activeCount: '{n}종 융합',
    stateActive: '활성',
    stateMissing: '결측',
    degradeBadge: '온도 결측 → 2종 융합 자동 전환 (γ=0, α·β 재정규화)',
    degradationNote: '온도 데이터 결측 시 γ=0 으로 두고 α·β 를 합이 1이 되도록 재정규화하여 2종 융합으로 자동 전환합니다.',
  },
  judgment: {
    subtitle: 'STEP3의 3종 융합 결과(S)를 이용해 제품의 최종 양/불과 불량 유형을 판정하고 근거(기여 모달리티)를 제시',
    fusionScore: '융합 점수 S',
    confidence: '신뢰도',
    threshold: '임계값 {value}',
    thresholdOver: '초과 → 불량 판정',
    thresholdUnder: '이하 → 양품 판정',
    defectTypeTitle: '불량 유형 분류',
    legendOver: '임계 초과 유형',
    contribTitle: '판정 근거 · 기여 모달리티',
    tempLed: '온도민감 주도',
    noteHead: '본 판정은 {label} 기여 {percent}%로,',
    noteThermal: '열화상이 온도민감 불량(휨·수축) 검출을 주도했습니다.',
    noteOther: '{label} 신호가 판정을 주도했습니다.',
    annotationTitle: '결함 영역 어노테이션',
    productImage: '제품 이미지',
    annotationNg: '불량 의심 영역 자동 표시',
    annotationOk: '이상 영역 없음 (양품)',
    historyTitle: '최근 판정 이력',
    verdict: '판정',
    defectType: '불량유형',
    contribModality: '기여 모달리티',
    kpi: {
      f1: '종합 F1',
      recall: '온도민감 재현율',
      total: '누적 판정 수',
      rate: '불량률',
    },
    badge: {
      ok: '양품 (OK)',
      ng: '불량 (NG)',
    },
    contrib: {
      thermal: '온도(Sₜ)',
      vision: '비전(Sᵥ)',
      process: '공정(Sₚ)',
    },
    annotations: {
      warpage: '휨 의심',
      shrinkage: '수축 의심',
    },
  },
};

const modulec = {
  nav: {
    brandTitle: '모듈C · 온도 포함 권고~승인(HITL) 자율 품질관리',
    brandSub: 'AI 권고 → 작업자 승인 → 3중 세이프가드 (임계차단 · 롤백 · in-silico)',
    steps: {
      recommend: { title: '권고 생성·승인', desc: 'Recommend & Approve' },
      safeguard: { title: '세이프가드', desc: 'Safeguard' },
    },
  },
  common: {
    countSuffix: '{n}건',
    tempTag: '온도',
  },
  params: {
    injectionPressure: '사출압력',
    injectionSpeed: '사출속도',
    holdingPressure: '보압',
    moldTemp: '금형온도',
    coolingTime: '냉각시간',
  },
  paramStatus: {
    normal: '정상',
    warn: '주의',
    exceed: '임계초과',
  },
  recCaseStatus: {
    pending: '승인 대기',
    approved: '승인 완료',
  },
  approvalStatus: {
    pending: '승인 대기',
    approved: '승인 완료',
    rejected: '반려됨',
  },
  overallStatus: {
    safe: '안전 (정상)',
    blocked: '차단됨',
    rollbackWait: '롤백 대기',
  },
  changeLogStatus: {
    applied: '적용',
    rolledback: '롤백',
    blocked: '차단',
  },
  worker: {
    name: '김현수',
    name2: '이정민',
    shift: '주간 A조',
    role: '공정 담당',
    aiAuto: 'AI 자동',
  },
  timeline: {
    requested: { label: '승인 요청됨', desc: 'AI 권고 조건 생성 · 승인 요청' },
    reviewing: { label: '작업자 검토중', desc: '김현수 (주간 A조) 검토 진행' },
    decision: { label: '승인 / 반려', desc: '작업자 최종 결정 대기' },
    safeguard: { label: '세이프가드 검증', desc: '승인 시 세이프가드 단계로 전달' },
  },
  modal: {
    changeSummary: '변경 요약 ({n}개 파라미터)',
    param: '파라미터',
    current: '현재값',
    recommended: '권고값',
    worker: '담당자',
    confirmApply: '확인 및 적용',
    cancel: '취소',
  },
  recommend: {
    title: '권고 조건 생성',
    subtitle: '모듈B 융합 판정 결과(불량·원인)를 바탕으로 최적 공정조건을 AI가 자동 권고',
    meta: '대상 샷',
    listTitle: '권고 목록',
    paramTitle: '권고 조건 · 현재값 → 권고값',
    expectedReduction: '예상 불량률 저감',
    confidence: '권고 신뢰도',
    approvedBanner: '권고 조건 승인 완료 — 세이프가드 검증 단계로 전달됨',
    approvedShort: '권고 조건 승인 완료',
    goSafeguard: '세이프가드로 이동',
    approveHint: '선택한 권고 조건을 검토 후 바로 승인합니다. 승인 시 확인 절차를 거쳐 현장에 적용됩니다.',
    approveBtn: '권고 승인하기',
    modalTitle: '권고 조건 적용 확인',
    modalMessage: '{product} ({shot})의 권고 조건을 현장에 적용하시겠습니까?',
    modalWarning: '적용 시 즉시 공정에 반영됩니다. 반영 후에는 세이프가드 단계에서 롤백할 수 있습니다.',
    cols: {
      param: '공정 파라미터',
      current: '현재값',
      recommended: '권고값',
      delta: '변화량 (Δ)',
      range: '임계범위',
      status: '상태',
    },
    notes: {
      rec2048: '금형온도 상향·냉각시간 단축을 중심으로 온도민감 불량(휨·수축)의 직접 저감을 예상합니다.',
      rec2043: '사출압력·보압 상향으로 치수 불량(공정 주도)의 안정화를 예상합니다.',
      rec2041: '금형온도 상향이 온도민감 불량(휨) 저감을 주도합니다. 임계 경계 근접에 주의가 필요합니다.',
    },
  },
  safeguard: {
    subtitle: '승인된 조건의 현장 적용 전·후 안전을 확보하는 3중 세이프가드 (임계초과 차단 · 롤백 · in-silico 사전검증)',
    guard1: '① 임계초과 자동차단',
    guard2: '② 롤백 · 변경이력',
    guard3: '③ in-silico 사전검증',
    blocked: '차단',
    normal: '정상',
    guard1NoteBlocked: '임계범위를 벗어난 권고값이 감지되어 적용이 자동 차단되었습니다.',
    guard1NoteOk: '모든 권고값이 임계범위 내에 있어 적용 가능합니다.',
    rollbackBtn: '직전 조건으로 롤백',
    rollbackRequested: '롤백 요청됨',
    passed: '통과',
    failed: '실패',
    beforeExpected: '적용 전 예상',
    afterExpected: '가상검증 예상',
    twinVerified: '디지털트윈 가상 시뮬레이션 검증 완료',
    silicoNote: '완전 자동제어는 디지털트윈 가상 검증까지만 수행하며, 현장 직접 반영은 작업자 승인이 필수입니다.',
    verifyTitle: '적용 전/후 불량률 추이 검증',
    defectRate: '불량률',
    applied: '권고 적용',
    reduction: '불량률 저감',
    significance: '통계적 유의성',
    cumulativeShots: '누적 적용 샷 수',
    hourLabel: '{h}시',
    rollbackTitle: '직전 조건으로 롤백',
    rollbackMessage: '현재 적용된 조건을 취소하고 직전 공정조건으로 복원하시겠습니까?',
    rollbackWarning: '롤백 시 현재 권고 조건이 즉시 해제되고 직전 값으로 되돌아갑니다.',
    rollbackConfirm: '롤백 실행',
    cols: {
      time: '시각',
      param: '파라미터',
      change: '변경',
      actor: '적용자',
      status: '상태',
    },
  },
};

const moduleI18n = { moduleb, modulec };

export default moduleI18n;
